import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../data/mock';

const FAQ = () => {
  return (
    <section id="faq" className="py-20 bg-slate-950">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Preguntas <span className="text-yellow-400">Frecuentes</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Respondemos las consultas más comunes sobre nuestros servicios legales
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq) => (
              <AccordionItem 
                key={faq.id} 
                value={`item-${faq.id}`}
                className="bg-slate-900 border border-slate-800 rounded-lg px-6 hover:border-blue-600/50 transition-colors"
              >
                <AccordionTrigger className="text-left text-white hover:text-yellow-400 text-lg font-semibold py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-400 text-base leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Additional Help */}
          <div className="mt-12 bg-gradient-to-r from-blue-900/20 to-blue-800/20 border border-blue-700/30 rounded-xl p-8 text-center">
            <h3 className="text-2xl font-bold text-white mb-3">
              ¿Tiene Más Preguntas?
            </h3>
            <p className="text-gray-300 mb-6">
              Estamos aquí para ayudarle. Contáctenos y resolveremos todas sus dudas
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('contacto');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-gray-700 hover:bg-gray-600 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
            >
              Contactar Ahora
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
